/* eslint-disable @typescript-eslint/no-explicit-any */
import * as React from 'react';

type IArrowBackProps = React.HTMLProps<SVGSVGElement>;

export function ArrowBack(props: IArrowBackProps) {
  return (
    // eslint-disable-next-line react/forbid-elements
    <svg xmlns="http://www.w3.org/2000/svg" width="6" height="10" viewBox="0 0 6 10" {...(props as any)}>
      <path
        fill="#475258"
        fillRule="evenodd"
        //tslint:disable-next-line:max-line-length
        d="M5.719 1.628L2.32 5l3.398 3.372a.948.948 0 0 1 0 1.348.966.966 0 0 1-1.36 0L.282 5.674a.948.948 0 0 1 0-1.349L4.359.28a.968.968 0 0 1 1.36 0 .95.95 0 0 1 0 1.349z"
      />
    </svg>
  );
}
